import "../css/Header.css";
import DarkModeButton from "./DarkModeButton";

const Header = (): JSX.Element => (
  <div className="header">
    <h2 className="color-white">IP Info</h2>
    <DarkModeButton />
  </div>
);

export default Header;
